const transformMhcData = (data = {}) => {
  return Object.keys(data).length > 0 && data.status?.toLowerCase() === 'active'
    ? {
        [data.code?.coding?.code]: {
          id: data.id,
          abatementDateTime: data.abatementDateTime,
          asserterId: data.asserterId,
          asserterType: data.asserterType,
          category: data.category,
          code: data.code?.coding?.code,
          display: data.code?.coding?.display ?? '',
          onsetDateTime: data.onsetDateTime,
          patientId: data.patientId,
          status: data.status,
          updatedAt: data.updatedAt,
        },
      }
    : {};
};

export default transformMhcData;
